import { BuiltinAtoms } from '@lemon8/web-app-shared/atom';
import { $ArticleComments, $ArticleDetail, $ArticleGPTInfo, $ArticleRelatedPosts } from 'shared/atoms/article';
import {
  $SharerABTest,
  $SharerDetail,
  $FeatureFlags,
  $SharingEnterTraffic,
  $SharingCurrentTraffic,
} from 'shared/atoms/common';
import { $UserDetail, $UserPost, $UserRelatedUser } from 'shared/atoms/user';
import { $POIInfo, $POIPosts } from 'shared/atoms/poi';
import { $HashtagInfo, $HashtagRecentPost, $HashtagPopularPost } from './hashtag';

export * from './common';
export * from './article';
export * from './user';
export * from './poi';
export * from './hashtag';

export const HydrationAtomsMap = {
  $SharerABTest,
  $FeatureFlags,
  $SharerDetail,
  $SharingEnterTraffic,
  $SharingCurrentTraffic,
};

export const HydrationAtomFamiliesMap = {
  $ArticleDetail,
  $ArticleGPTInfo,
  $ArticleComments,
  $ArticleRelatedPosts,

  $UserDetail,
  $UserPost,
  $UserRelatedUser,

  $POIInfo,
  $POIPosts,

  $HashtagInfo,
  $HashtagRecentPost,
  $HashtagPopularPost,
};

export const Atoms = {
  ...BuiltinAtoms,
  ...HydrationAtomsMap,
  ...HydrationAtomFamiliesMap,
};
